var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDelete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 3.46587L4.16667 17.1592C4.27917 18.2742 6.83917 19.1667 9.98917 19.1667C13.1392 19.1667 15.6992 18.2742 15.8117 17.1592L17.4783 3.46587M12.5 9.16671L7.5 14.1667M12.5 14.1667L7.5 9.16671M17.5 3.33337C17.5 4.71409 14.1421 5.83337 10 5.83337C5.85786 5.83337 2.5 4.71409 2.5 3.33337C2.5 1.95266 5.85786 0.833374 10 0.833374C14.1421 0.833374 17.5 1.95266 17.5 3.33337Z",
    stroke: "#F02405",
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.cb6ad9f2.svg";
export { ForwardRef as ReactComponent };